<style lang="less" scoped>
tr, td {border: 1px solid #f5eeee;padding: 5px;border-bottom: 1px solid #f5eeee;}
.tr .td {float: left;}
.tr {width: 100%;height: 50px;}
.table {border-collapse: collapse;width: 100%;}
.select1 .el-input__inner {width: 150px;}
.ziduanKey .el-input__inner {width: 340px;}
.level .el-input__inner {width: 150px;}
.sort .el-input__inner {width: 150px;}
.input2 {width: 50px;}
.input2 .el-input__inner {width: 50px;}
.date-picker.el-input {width: 200px;}
.inputID {width: 50px;margin-right: 10px;}
.count .el-input__inner {width: 50px;}
.el-checkbox {margin-right: 0px;}
.el-checkbox__inner {border-radius: 50%;}
.btnbox {width: 100%;text-align: left;border-bottom: 1px solid #e7e7eb;height: 60px;margin-bottom: 40px;}
.btnbox .elbtn {margin-top: 10px;margin-left: 15px;}
.recycling_box .delete {margin-left: 40px;}
.btnbox .level {margin-left: 10px;}
.el-form-item {float: left;margin-bottom: 0px;}
.el-pagination {text-align: center;}
.el-form table {width: 100%;}
.tr1 td .el-form-item /deep/.el-form-item__content {margin-left: 10px;}
.tr2 td .el-form-item /deep/.el-form-item__content {margin-left: 10px;}
.select1 /deep/ .el-input__inner {width: 150px;}
.ziduanKey /deep/ .el-input__inner {width: 340px;}
.level /deep/ .el-input__inner {width: 150px;}
.sort /deep/ .el-input__inner {width: 150px;}
.count /deep/ .el-input__inner {width: 50px;}
.pagination{margin-bottom: 40px;}
</style>

<template>
  <div class="second" id="second">
    <div class="dmkclb—_box second">
      <!--搜索框-->
      <el-form ref="form" :model="form">
        <table class="dmkclb">
          <tr class="tr tr1">
            <td>
              <el-form-item>
                <div class="td td1">
                  <el-select v-model="ziduan" placeholder="请选择">
                    <el-option v-for="item in options1" :key="item.value" :label="item.label" :value="item.key"></el-option>
                  </el-select>
                </div>
              </el-form-item>
              <el-form-item>
                <div class="td">
                  <el-input v-model="form.title" placeholder="请输入关键词" class="input ziduanKey"></el-input>
                </div>
              </el-form-item>
              <el-form-item>
                <div class="td">
                  <el-select v-model="form.sort" placeholder="请选择">
                    <el-option v-for="item in result_data" :key="item.value" :label="item.label" :value="item.value"></el-option>
                  </el-select>
                </div>
              </el-form-item>
              <el-form-item>
                <div class="td">
                  <el-input v-model="form.count" placeholder="20" class="input count"></el-input>
                </div>
              </el-form-item>
              <el-form-item>
                <div class="td">
                  <el-button class="elbtn search" @click="search">搜索</el-button>
                  <el-button class="elbtn reset" @click="cancelfnBtn">重置</el-button>
                </div>
              </el-form-item>
            </td>
          </tr>
          <tr class="tr tr2">
            <td>
              <el-form-item>
                <div class="td">
                  <el-date-picker v-model="form.addtime" type="datetime" placeholder="选择开始日期" class="date-picker"></el-date-picker>
                  <span style="display: inline-block;width: 32px;text-align: center;">至</span>
                  <el-date-picker v-model="form.edittime" type="datetime" placeholder="选择结束日期" class="date-picker"></el-date-picker>
                </div>
              </el-form-item>
              <el-form-item>
                <div class="td">
                  <el-select v-model="form.type" placeholder="请选择分类">
                    <el-option v-for="item in classifydata" :key="item.value" :label="item.label" :value="item.value"></el-option>
                  </el-select>
                </div>
              </el-form-item>
              <el-form-item>
                <div class="td">
                  <el-button type="success" v-if="parms === 'Hyfbgl'" @click="addfn()">添加</el-button>
                </div>
              </el-form-item>
            </td>
          </tr>
        </table>
      </el-form>
      <!--上传列表-->
      <div class="el-tablebox">
        <el-table
          ref="multipleTable"
          :data="TableData"
          style="width: 100%"
          @selection-change="handleSelectionChange"
          stripe
          border
          :cell-style="{ textAlign: 'center'}"
          :header-cell-style="{background: '#F5F5F5',color: '#606266',textAlign: 'center'}">
          <el-table-column type="selection" width="40"></el-table-column>
          <el-table-column prop="type" label="分类" width="100"></el-table-column>
          <el-table-column prop="title" label="标题"  :show-overflow-tooltip="true"> </el-table-column>
          <el-table-column prop="introduce" label="简介" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="addtime" label="添加时间" width="160">
            <template slot-scope="scope">{{(scope.row.addtime * 1000) | formatTime()}} </template>
          </el-table-column>
          <el-table-column prop="status" label="状态" width="70"></el-table-column>
          <el-table-column label="审核" width="150">
            <template slot-scope="scope">{{ scope.row.examine | examine_data() }}</template>
          </el-table-column>
          <el-table-column prop="id" label="操作" width="180">
            <template slot-scope="scope">
              <el-button type="primary" v-if="show1" @click="look(scope.row)">审核</el-button>
              <el-button type="success" v-if="show3" @click="release(scope.row)">发布</el-button>
              <el-button type="warning" v-if="show2" @click="updatafn(scope.row)">修改</el-button>
              <el-button type="danger" v-if="show2" @click="deletefn(11, 53, scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="btnbox">
        <el-button type="danger" class="elbtn delete" @click="deletesfn(11, 53)">批量删除</el-button>
      </div>
    </div>
    <!--底部分页-->
    <div class="block">
      <el-pagination
        class="pagination"
        @size-change="handleSizeChange(this.form.count)"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-size="pageSize"
        layout="total, prev, pager, next, jumper"
        :total="countSum">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import filters from '../../method/filter'
import methods from '../../method/methods'
import {mapState} from 'vuex'
export default {
  mixins: [filters, methods],
  data()
  {
    return {
      ziduan: 'title',
      form: {
        title: '',
        sort: '',
        count: 20,
        addtime: '',
        edittime: '',
        type: ''
      },
      //分页数据
      pageSize: 20,
      currentPage: 1,
      countSum: null,
      //分类数据
      classifydata: [],
      //列表数据
      tableData: [],
      show1: false,
      show2: false,
      show3: false,
      parms: '',
      //————下拉数据————
      options1: [
        { value: '选项1', label: '标题', key: 'title' },
        { value: '选项2', label: '关键词', key: 'tag' },
        { value: '选项3', label: '简介', key: 'introduce' }
      ],
      //级别选项
      level_data: [
        { value: '1', label: '1 级 网站首页推荐' },
        { value: '2', label: '2 级' },
        { value: '3', label: '3 级' },
        { value: '4', label: '4 级' },
        { value: '5', label: '5 级' },
        { value: '6', label: '6 级' },
        { value: '7', label: '7 级' },
        { value: '8', label: '8 级' },
        { value: '9', label: '9 级' }
      ],
      //结果排序选项
      result_data: [
        { value: '选项1', label: '添加时间降序', description: 'addtime DESC' },
        { value: '选项2', label: '添加时间升序', description: 'addtime ASC' },
        { value: '选项3', label: '更新时间降序', description: 'edittime DESC' },
        { value: '选项4', label: '更新时间升序', description: 'edittime ASC' },
        { value: '选项5', label: '浏览次数降序', description: 'hits DESC' },
        { value: '选项6', label: '浏览次数升序', description: 'hits ASC' },
        { value: '选项7', label: '信息ID降序', description: 'id DESC' },
        { value: '选项8', label: '信息ID升序', description: 'id ASC' }
      ],
      member_data: [
        { value: '选项1', label: '注册时间降序', description: 'regtime DESC' },
        { value: '选项2', label: '注册时间升序', description: 'regtime ASC' },
        { value: '选项7', label: '信息ID降序', description: 'id DESC' },
        { value: '选项8', label: '信息ID升序', description: 'id ASC' }
      ],
      //日期方式排序选项
      time_data: [
        { value: 'edittime', label: '更新日期' },
        { value: 'addtime', label: '发布日期' }
      ],
      //所属国家选项
      ssgj_data: [
        { value: 0, label: '不限地区' },
        { value: 2, label: '中国' },
        { value: 3, label: '印度尼西亚' },
        { value: 4, label: '马来西亚' },
        { value: 5, label: '菲律宾' },
        { value: 6, label: '新加坡' },
        { value: 7, label: '泰国' },
        { value: 8, label: '文莱' },
        { value: 9, label: '越南' },
        { value: 10, label: '老挝' },
        { value: 11, label: '缅甸' },
        { value: 12, label: '柬埔寨' },
        { value: 13, label: '其它' },
        { value: 14, label: '东帝汶' }
      ]
    }
  },
  computed:
  {
    TableData()
    {
      return this.tableData
    },
    ...mapState({
      nodeid: state => state.NavID,
      IsLb: state => state.IsLb
    })
  },
  watch:
  {
    nodeid:
    {
      handler(nval, oval)
      {
        //获取分类下拉列表
        window.public.getFldvalue(this.nodeid, 'type').then(res =>
        {
          this.classifydata = []
          res.forEach(e => this.classifydata.push({ value: e.dispc, label: e.dispc }))
        })
      },
      immediate: true
    },
    IsLb:
    {
      handler(nval, oval)
      {
        if (nval === '1')
          this.getList()
        this.$store.commit('onIsLb', '0')
      },
      deep: true,
      immediate: true
    }
  },
  created()
  {
    this.urlpath = window.location.href
    this.parms = this.urlpath.substring(this.urlpath.lastIndexOf('/') + 1)
    this.getList()
    if (this.parms === 'ToRelease')
    {
      this.show3 = true
      this.show1 = false
      this.show2 = false
    }
    if (this.parms === 'ToExamine')
    {
      this.show1 = true
      this.show2 = false
      this.show3 = false
    }
    if (this.parms === 'Hyfbgl')
    {
      this.show2 = true
      this.show1 = false
      this.show3 = false
    }
  },
  methods:
  {
    //查询列表
    getList()
    {
      let userInfo = JSON.parse(localStorage.getItem('userMsg'))
      let count = this.form.count
      let ziduan = this.ziduan
      //将标准时间转化为时间戳
      let addtime = this.form.addtime.valueOf() / 1000
      let edittime = this.form.edittime.valueOf() / 1000
      //构造请求语句
      let exp = ''
      let reorder = ''
      //循环筛选条件
      for (let e in this.form)
      {
        let item = this.form[e]
        if (item && e === 'title')
          exp += `${ziduan} like '%${item}%' and `
        if (item && e === 'addtime')
          exp += `addtime >= ${addtime} and `
        if (item && e === 'edittime')
          exp += `addtime <= ${edittime} and `
        if (item && e === 'type' && item !== '不限分类')
          exp += `type = '${item}' and `
        if (item && e === 'sort')
          reorder = `${item}`
      }
      reorder = reorder ? reorder : `id DESC`

      if (this.parms === 'Hyfbgl')
        exp = exp ? `${exp}id != 0` : 'id>0'
      else if (this.parms === 'ToExamine')
      {
        let exaary = userInfo.role.toString()
        if (exaary === '0')
          exp = exp ? `${exp}A.id != 0` : 'A.id > 0 and examine in (1,2,3)'
        else
          exp = exp ? `${exp}A.id != 0` : `A.id > 0 and examine in (${exaary})`
      }
      else if (this.parms === 'ToRelease')
      {
        if (userInfo.role.indexOf(6) !== -1 || userInfo.role.indexOf(0) !== -1)
          exp = exp ? `${exp}id != 0` : 'id>0 and examine = 5'
      }
      this.find(11, 53, exp, 0, this.currentPage, count, reorder).then((ret) =>
      {
        if (ret.length > 0)
        {
          this.countSum = ret[0].total
          this.tableData = []
          ret[0].data.forEach((item) =>
          {
            this.tableData.push({
              id: item.id,
              type: item.type,
              title: item.title,
              introduce: item.introduce,
              addtime: item.addtime,
              status: item.status,
              examine: item.examine
            })
          })
        }
        else
          return false
      })
    },
    //点击修改
    updatafn(row)
    {
      this.$router.push({path: '/HyfbglUpdate', query: {id: row.id}})
    },
    //点击查看
    look(row)
    {
      this.$router.push({path: '/HyfbLook', query: {id: row.id}})
    },
    release(row)
    {
      let objcontent = {
        cmd: 'updateAtt',
        _major: 11,
        _minor: 53,
        retAtt: 1,
        id: row.id,
        examine: 0
      }
      window.post.getPost(objcontent).then((ret) =>
      {
        if (ret.ret === 1)
          this.$message({message: '发布失败', type: 'error', customClass: 'mzindex'})
        else
        {
          this.$message({message: '发布成功', type: 'success', customClass: 'mzindex'})
          this.dialogVisible = false
          this.$router.push({path: '/ToRelease'})
          this.getList()
        }
      })
    },
    /**
     * 彻底删除--单
     * 获取下拉框列表
     * @param {String} major  //主类型
     * @param {String} minor  //子类型
     */
    deletefn(major, minor, row)
    {
      let that = this
      window.public.deletefn(major, minor, row, that)
    },
    /**
     * 彻底删除——多
     * 获取下拉框列表
     * @param {String} major  //主类型
     * @param {String} minor  //子类型
     */
    deletesfn(major, minor)
    {
      let that = this
      window.public.deletesfn(major, minor, that)
    },
    //子组件调用新增添加Tabs
    addfn()
    {
      this.$emit('addTab')
    },
    //————列表页的公共方法————
    //搜索
    search()
    {
      this.getList()
      this.handleSizeChange(this.form.count)
    },
    //重置搜索条件
    cancelfnBtn()
    {
      let str = 'count'
      let that = this
      window.public.cancelfnBtn(str, that)
    },
    //当选择项发生变化时会触发该事件
    handleSelectionChange(val)
    {
      let temp = []
      val.forEach((item) => temp.push(item.id))
      this.multipleSelection = temp
    },
    //每页条数
    handleSizeChange(val)
    {
      this.pageSize = val
    },
    //当前页数
    handleCurrentChange(val)
    {
      this.currentPage = val
      this.search()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/plugins/backer/assembly/xsyz/Hyfblb.vue